module.exports = __webpack_public_path__ + "static/img/bg-fr.c8017173.webp";